import { render, staticRenderFns } from "./account-su-updates-update.html?vue&type=template&id=39e70768&scoped=true&"
import script from "./account-su-updates-update.js?vue&type=script&lang=js&"
export * from "./account-su-updates-update.js?vue&type=script&lang=js&"
import style0 from "./account-su-updates-update.scss?vue&type=style&index=0&id=39e70768&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e70768",
  null
  
)

export default component.exports